import { takeEvery, put, call } from 'redux-saga/effects';
import { Creators, Types } from 'src/store/redux/statistics-me/actions';
import statisticsAPI from 'src/services/api/statistics';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* getProviderPerformance(filters: any = null) {
  try {
    // @ts-ignore: Unreachable code error
    
    const response = yield call(statisticsAPI.providerPerformanceStats, filters);
    yield put(
      Creators.statisticsMeProviderPerformanceRequestSuccess(response.data)
    );
  } catch (e) {
    let error = e;
    DBErrorMonitor.captureException(e, {
      saga: 'getPrroviderPerformance',
      entity: 'statistics',
    });
    handleErrorResponse(error);
    yield put(Creators.statisticsMeProviderPerformanceRequestError(error));
  }
}

export function* watchGetProviderPerformance() {
  yield takeEvery(
    Types.STATISTICS_ME_PROVIDER_PERFORMANCE_REQUEST,
    getProviderPerformance
  );
}

export default watchGetProviderPerformance;
